var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('el-button',{staticClass:"print-button",on:{"click":function($event){return _vm.print()}}},[_vm._v(" Imprimir ")]),_c('div',{staticClass:"back-wrapper"},[_c('Func4BackButton',{nativeOn:{"click":function($event){return _vm.back()}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }